import withCollegeService from '../withCollegeService';
import AvgAmountOfAid from './avgAmountOfAid';
import AvgNetPrices from './avgNetPrices';
import PercentageReceivingAid from './percentageReceivingAid';

export const AvgAmountOfAidComponent = withCollegeService(
  AvgAmountOfAid,
  'costs.averageAmountOfAid',
  {},
  {
    grant: 'field_he_value',
    pellGrant: 'field_he_value',
    studentLoan: 'field_he_value',
  },
);

export const AvgNetPricesComponent = withCollegeService(
  AvgNetPrices,
  'costs.averageNetPrices',
  {},
  {
    '0-30': 'field_he_value',
    '30-48': 'field_he_value',
    '48-75': 'field_he_value',
    '75-110': 'field_he_value',
    '110+': 'field_he_value',
  },
);

export const PercentageReceivingAidComponent = withCollegeService(
  PercentageReceivingAid,
  'costs.receivingAid',
  {},
  {
    grant: 'field_he_value',
    pellGrant: 'field_he_value',
    studentLoan: 'field_he_value',
  },
);

export {
  AvgAmountOfAidComponent as AvgAmountOfAid,
  AvgNetPricesComponent as AvgNetPrices,
  PercentageReceivingAidComponent as PercentageReceivingAid,
};
